const axios = require('axios')
const interactionUrl = process.env.REACT_APP_HOST_API + '/interactions'

export const createInteraction = async (interactionData) => {
  try {
    const response = await axios.post(interactionUrl, {
      userId: interactionData.userId,
      sessionId: interactionData.sessionId,
      questionType: interactionData.questionType,
      studentIntent: interactionData.studentIntent,
      studentFacingDescription: interactionData.studentFacingDescription, 
      codeSnapshot: interactionData.codeSnapshot,
      messageHistory: interactionData.messageHistory
    })
    return response.data
  } catch (error) {
    console.error('Error creating interaction:', error)
  }
}

export const getInteractionsBySession = async (sessionId) => {
  try {
    const response = await axios.get(`${interactionUrl}/session/${sessionId}`)
    return response.data
  } catch (error) {
    console.error('Error fetching interactions by session:', error)
    return []
  }
}

export const getInteractionsByUser = async (userId, sessionId) => {
  try {
    const response = await axios.get(`${interactionUrl}/user/${userId}/session/${sessionId}`)
    return response.data
  } catch (error) {
    console.error('Error fetching interactions by user:', error)
    return []
  }
}